/**
 * useClockRounds - the combat round moved: the per-round clocks fill
 * (v9.5.11), on a screen that directs and only while the order runs.
 *
 * `tickRound` is idempotent per round (a clock's `roundAt`), so a reload
 * or a second directing tab adds nothing. It is also asked when a
 * per-round clock has NO stamp yet: a clock switched to "Fills each round"
 * in the middle of round 1 is stamped then, or round 2 - the first it is
 * seen at - would only stamp it and fill nothing.
 *
 * @param {boolean} canDirect
 * @param {{ active: boolean, round: number } | undefined} tracker - the turn tracker's state
 * @param {{ perRound: boolean, roundAt: number | null }[]} clocks
 * @param {(round: number | null) => void} tickRound
 */
import { useEffect } from 'react';

export default function useClockRounds(canDirect, tracker, clocks, tickRound) {
  const round = tracker?.active ? tracker.round : null;
  const unstamped = clocks.filter((c) => c.perRound && c.roundAt === null).length;
  useEffect(() => {
    // `null` says no order is running: the clocks forget the round they last counted.
    if (canDirect) tickRound(round);
  }, [canDirect, round, unstamped, tickRound]);
}
